import React from 'react';
import { GenericPaginatedDocument } from '@/components/print/GenericPaginatedDocument';
import {
  buildSubcontractAgreementPrintModel,
  buildSubcontractCertificatePrintModel,
  buildSubcontractFinalAccountPrintModel,
} from '@/utils/epcSubcontractPrint';

export type PrintableSubcontractProps = {
  kind: 'agreement' | 'certificate' | 'final_account';
  agreement?: Record<string, unknown>;
  certificate?: Record<string, unknown>;
  finalAccount?: Record<string, unknown>;
  supplierName?: string;
  projectLabel?: string;
  onClose?: () => void;
};

export const PrintableSubcontractDocument: React.FC<PrintableSubcontractProps> = ({
  kind,
  agreement,
  certificate,
  finalAccount,
  supplierName,
  projectLabel,
  onClose,
}) => {
  const model =
    kind === 'certificate'
      ? buildSubcontractCertificatePrintModel({
          certificate: certificate || {},
          agreement,
          supplierName,
          projectLabel,
        })
      : kind === 'final_account'
        ? buildSubcontractFinalAccountPrintModel({
            finalAccount: finalAccount || {},
            agreement,
            supplierName,
          })
        : buildSubcontractAgreementPrintModel({
            agreement: agreement || {},
            supplierName,
            projectLabel,
          });

  return <GenericPaginatedDocument model={model} onClose={onClose} />;
};

export const PrintableSubcontractAgreement: React.FC<
  Omit<PrintableSubcontractProps, 'kind'>
> = (props) => <PrintableSubcontractDocument {...props} kind="agreement" />;

export const PrintableSubcontractCertificate: React.FC<
  Omit<PrintableSubcontractProps, 'kind'>
> = (props) => <PrintableSubcontractDocument {...props} kind="certificate" />;

export const PrintableSubcontractFinalAccount: React.FC<
  Omit<PrintableSubcontractProps, 'kind'>
> = (props) => <PrintableSubcontractDocument {...props} kind="final_account" />;

export default PrintableSubcontractDocument;
